import * as React from 'react';
import { Route, Switch } from 'react-router-dom';

import QuizanswerList from './quizanswer-list.component';
import QuizanswerCreate from './quizanswer-create.component';
import QuizanswerView from './quizanswer-view.component';
import QuizanswerEdit from './quizanswer-edit.component';
import QuizanswerCopy from './quizanswer-copy.component';
import QuizanswerDelete from './quizanswer-delete.component';

interface Props {
  root?: string;
}

export const QuizanswerRoute: React.FunctionComponent<Props> = (props) => {

  return (
    <Switch>
      <Route path={(props.root||'') + '/quizanswer/create'} component={QuizanswerCreate} />
      <Route path={(props.root||'') + '/quizanswer/view'} component={QuizanswerView} />
      <Route path={(props.root||'') + '/quizanswer/edit'} component={QuizanswerEdit} />
      <Route path={(props.root||'') + '/quizanswer/copy'} component={QuizanswerCopy} />
      <Route path={(props.root||'') + '/quizanswer/delete'} component={QuizanswerDelete} />
      <Route path={(props.root||'') + '/quizanswer'} component={QuizanswerList} />
    </Switch>
  );
}
